import React, { Component } from 'react';

import {unmountComponentAtNode} from 'react-dom';

export const clearmain = ()=>{

let isclear = true;
   try{
       const maindiv = document.getElementById('container') as HTMLElement;
	if(maindiv){
	unmountComponentAtNode(maindiv);
	}
     }
     catch(e){
     isclear = false;
    }	
  return isclear;
	

};
export const cleardv = (id:any)=>{

let isclear = true;
   try{
       const maindiv = document.getElementById(id) as HTMLElement;
	if(maindiv){
	unmountComponentAtNode(maindiv);
        
	}
     }
     catch(e){
     isclear = false;
    }	
  return isclear;
	

};

export const clearprofile = ()=>{

let isclear = true;
   try{
       const profilediv = document.getElementById('profilediv') as HTMLElement;
	if(profilediv){
	unmountComponentAtNode(profilediv);
	}
     }
     catch(e){
     isclear = false;
    }	
  return isclear;
	

};
